import { Warehouse } from "lucide-react";
import { fmtDate } from "@/lib/format";

export const needsStorage = (job) => Boolean(job?.move_in_date && job?.storage_days > 0);
export const storageText = (job) => `Move-in ${fmtDate(job.move_in_date)} · storage ${job.storage_days} day${job.storage_days === 1 ? "" : "s"}`;

export function StorageBadge({ job, className = "", short = false }) {
  if (!needsStorage(job)) return null;
  return (
    <span className={`inline-flex items-center gap-1 rounded-md bg-orange-50 text-orange-700 border border-orange-200 px-2 py-0.5 text-xs font-medium ${className}`} data-testid={`storage-badge-${job.id}`}>
      <Warehouse className="h-3.5 w-3.5 shrink-0" />{short ? `Storage ${job.storage_days} day${job.storage_days === 1 ? "" : "s"}` : storageText(job)}
    </span>
  );
}
